import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/iconR
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Close from "@material-ui/icons/Close";
import Done from "@material-ui/icons/Done";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import PropTypes from "prop-types";
import InputLabel from "@material-ui/core/InputLabel";
import CustomInput from "components/CustomInput/CustomInput.js";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Info from "@material-ui/icons/Info";

import SweetAlert from "react-bootstrap-sweetalert";

import moment from "moment";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import axios from "axios";

import * as Constants from "constants.js";

axios.defaults.withCredentials = true;

const { REACT_APP_SERVER_URL } = process.env;

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "left",
  },
};

const alertOverrides = {
  marginTop: "-100px",
  marginRight: "0px",
  marginBottom: "0px",
  marginLeft: "0px",
};

const useStylesAlert = makeStyles(stylesAlert);

const useStylesModal = makeStyles(stylesModal);

const useStylesCard = makeStyles(stylesCard);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function Admin(props) {
  const classesAlert = useStylesAlert();
  const classesModal = useStylesModal();
  const classesCard = useStylesCard();

  const classes = { ...classesAlert, ...classesModal, ...classesCard };

  const [id, setID] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailState, setEmailState] = React.useState("");
  const [name, setName] = React.useState("");
  const [institution, setInstitution] = React.useState("");
  const [about, setAbout] = React.useState("");

  const [typeNumeric, setTypeNumeric] = React.useState("2");
  const [statNumeric, setStatNumeric] = React.useState("1");

  const [agenda_time, setTime] = React.useState("");
  const [agenda_topic, setTopic] = React.useState("");
  const [confirmation_code, setConfirmationCode] = React.useState("");
  const [registration_type, setRegistrationType] = React.useState("");
  const [need_time, setNeedTime] = React.useState("");
  const [role, setRole] = React.useState("");

  const [type, setType] = React.useState("");
  const [description, setDescription] = React.useState("");

  const [alert, setAlert] = React.useState(null);

  const [addUserModal, setAddUserModal] = React.useState(false);

  const [updateUserModal, setUpdateUserModal] = React.useState(false);

  const [registrationInfoModal, setRegistrationInfoModal] = React.useState(
    false
  );

  const [dataRequestsInfoModal, setDataRequestsInfoModal] = React.useState(
    false
  );

  const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  const addRegistrationData = (registrationData) => {
    setID(registrationData.id);
    setTime(registrationData.agenda_time);
    setTopic(registrationData.agenda_topic);
    setConfirmationCode(registrationData.confirmation_code);
    setInstitution(registrationData.institution);
    setEmail(registrationData.email);
    setName(registrationData.name);
    setNeedTime(registrationData.need_time);
    setRole(registrationData.role);
    setRegistrationType(registrationData.registration_type);
  };

  const addDataRequestsData = (requestData) => {
    setID(requestData.id);
    setName(requestData.name);
    setEmail(requestData.email);
    setInstitution(requestData.institution);
    setType(requestData.type);
    setDescription(requestData.description);
  };

  const votes = props.attendance.filter((attendance) => {
    return attendance.type.indexOf("vote") > -1;
  });

  const mostRecentVotes = Object.values(
    votes.reduce((r, o) => {
      if (!r[o.email] || r[o.email].dateTime < o.dateTime) r[o.email] = o;
      return r;
    }, {})
  );

  const emeriaudVotes = mostRecentVotes.filter((vote) => {
    return vote.type.indexOf("emeriaud") > -1;
  }).length;

  const abusultanehVotes = mostRecentVotes.filter((vote) => {
    return vote.type.indexOf("abusultaneh") > -1;
  }).length;

  const grunwellVotes = mostRecentVotes.filter((vote) => {
    return vote.type.indexOf("grunwell") > -1;
  }).length;

  const statTypeText =
    statNumeric == 2
      ? "palicc_prevent_symposium_2022"
      : statNumeric == 3
      ? Constants.CURRENT_MEETING
      : "";

  const selectedRegistrations = props.registrations.filter((registration) => {
    return registration.conference_name == statTypeText;
  });

  const selectedRegistrationsTotal = selectedRegistrations.length;

  const inPersonRegistrations = selectedRegistrations.filter((registration) => {
    return registration.registration_type == "in_person";
  }).length;

  const virtualRegistrations = selectedRegistrations.filter((registration) => {
    return registration.registration_type == "virtual";
  }).length;

  const userEmails = props.users.map((user) => {
    return user.email;
  });

  const userEmailsString = userEmails.join("; ");

  const registrationData = selectedRegistrations.map((prop) => {
    return {
      id: prop.id,
      agenda_time: prop.agenda_time,
      agenda_topic: prop.agenda_topic,
      confirmation_code: prop.confirmation_code,
      institution: prop.institution,
      email: prop.email,
      name: prop.name,
      need_time: prop.need_time ? "Yes" : "",
      role: prop.role,
      registration_type: prop.registration_type,
      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findEmailIndex = ({ email }) => {
                return email == prop.email;
              };

              const emailIndex = selectedRegistrations.findIndex(
                findEmailIndex
              );

              const registrationData = selectedRegistrations[emailIndex];

              addRegistrationData(registrationData);

              setRegistrationInfoModal(true);
            }}
            color="info"
            className="like"
          >
            <Info />
          </Button>{" "}
        </div>
      ),
    };
  });

  const dataRequestsData = props.dataRequests.map((prop) => {
    return {
      id: prop.id,
      name: prop.name,
      email: prop.email,
      institution: prop.institution,
      type: prop.type,
      description: prop.description,

      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findIdIndex = ({ id }) => {
                return id == prop.id;
              };

              const idIndex = props.dataRequests.findIndex(findIdIndex);

              const requestData = props.dataRequests[idIndex];

              addDataRequestsData(requestData);

              setDataRequestsInfoModal(true);
            }}
            color="info"
            className="like"
          >
            <Info />
          </Button>{" "}
        </div>
      ),
    };
  });

  const attendanceOnlyData = props.attendance.filter((attendance) => {
    return attendance.type.indexOf("vote") == -1;
  });

  const attendanceWithKey = attendanceOnlyData.map((item) => ({
    /// WANT KEY FOR GROUPING SUMMARY TO BE EMAIL AND TYPE OF ATTENDANCE
    ...item,
    key: item.email + item.type,
  }));

  const mostRecentAttendance = Object.values(
    attendanceWithKey.reduce((r, o) => {
      if (!r[o.key] || r[o.key].dateTime < o.dateTime) r[o.key] = o;
      return r;
    }, {})
  );

  const attendanceSymposium = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "symposium";
  });

  const attendanceMeeting = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "meeting";
  });

  const attendanceMeeting0622 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "meeting_06_22";
  });

  const attendanceMeeting0922 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_09_22";
  });

  const attendanceMeeting0123 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_01_23";
  });

  const attendanceMeeting0323 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_03_23";
  });

  const attendanceMeeting0623 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_06_23";
  });

  const attendanceMeeting0923 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_09_23";
  });

  const attendanceMeeting1223 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_12_23";
  });

  const attendanceMeeting0324 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_03_24";
  });

  const attendanceMeeting0524 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_05_24";
  });
  const attendanceMeeting0924 = mostRecentAttendance.filter((attendance) => {
    return attendance.type == "prevent_meet_09_24";
  });


  const symposiumAttendanceTotal = attendanceSymposium.length;

  const meetingAttendanceTotal = attendanceMeeting.length;

  const meeting0622AttendanceTotal = attendanceMeeting0622.length;

  const meeting0922AttendanceTotal = attendanceMeeting0922.length;

  const meeting0123AttendanceTotal = attendanceMeeting0123.length;

  const meeting0323AttendanceTotal = attendanceMeeting0323.length;

  const meeting0623AttendanceTotal = attendanceMeeting0623.length;

  const meeting0923AttendanceTotal = attendanceMeeting0923.length;

  const meeting1223AttendanceTotal = attendanceMeeting1223.length;

  const meeting0324AttendanceTotal = attendanceMeeting0324.length;

  const meeting0524AttendanceTotal = attendanceMeeting0524.length;

  const meeting0924AttendanceTotal = attendanceMeeting0924.length;

  const attendanceData = mostRecentAttendance.map((prop) => {
    const date = new Date(prop.dateTime);
    const dateFormat = moment(date).local().format("MM-DD-YYYY hh:mm a");

    return {
      id: prop.id,
      name: prop.name,
      email: prop.email,
      type: prop.type,
      dateTime: dateFormat,

      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
        </div>
      ),
    };
  });

  const tentativeData = props.users.filter((user) => {
    return user.tentative == "true";
  });

  console.log(tentativeData);

  const tentativeUserData = tentativeData.map((prop) => {
    return {
      id: prop.id,
      email: prop.email,
      type: prop.name,
      name: prop.name,
      institution: prop.institution,
      about: prop.about,
      tentative: prop.tentative,
      message: prop.message,
      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findEmailIndex = ({ email }) => {
                return email == prop.email;
              };

              const emailIndex = tentativeData.findIndex(findEmailIndex);

              const userData = tentativeData[emailIndex];

              addTentativeData(userData);

              confirmApproveUser(
                prop.id,
                prop.email,
                prop.name,
                prop.institution,
                prop.about
              );
            }}
            color="success"
            className="success"
          >
            <Done />
          </Button>
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findEmailIndex = ({ email }) => {
                return email == prop.email;
              };

              const emailIndex = tentativeData.findIndex(findEmailIndex);

              const userData = tentativeData[emailIndex];

              addTentativeData(userData);
              confirmDenyUser(prop.id, prop.name, prop.email);
            }}
            color="danger"
            className="remove"
          >
            <Close />
          </Button>{" "}
        </div>
      ),
    };
  });
  const userData = props.users.map((prop) => {
    return {
      id: prop.id,
      email: prop.email,
      type: prop.type,
      name: prop.name,
      institution: prop.institution,
      about: prop.about,
      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findEmailIndex = ({ email }) => {
                return email == prop.email;
              };

              const emailIndex = props.users.findIndex(findEmailIndex);

              const userData = props.users[emailIndex];

              userData.typeNumeric =
                userData.type == "member_admin"
                  ? 3
                  : userData.type == "admin"
                  ? 4
                  : 2;

              addData(userData);

              setUpdateUserModal(true);
            }}
            color="warning"
            className="like"
          >
            <Dvr />
          </Button>{" "}
          {/* use this button to remove the data row */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findEmailIndex = ({ email }) => {
                return email == prop.email;
              };

              const emailIndex = props.users.findIndex(findEmailIndex);

              const userData = props.users[emailIndex];

              addData(userData);

              confirmDeleteUser(prop.id, prop.name);
            }}
            color="danger"
            className="remove"
          >
            <Close />
          </Button>{" "}
        </div>
      ),
    };
  });

  const hideAlert = () => {
    setAlert(null);
  };

  const confirmDeleteUser = (id, name) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title="Are you sure?"
        onConfirm={() => handleDeleteUser(id)}
        onCancel={() => cancelDeleteUser(name)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      >
        {name} will be deleted!
      </SweetAlert>
    );
  };

  const cancelDeleteUser = (name) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {name} Not Deleted!
      </SweetAlert>
    );
  };

  const successAddUser = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setAddUserModal(false);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        User Added!
      </SweetAlert>
    );
  };

  const failAddUser = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        User not added!
      </SweetAlert>
    );
  };

  const successDeleteUser = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {name} Deleted!
      </SweetAlert>
    );
  };

  const failDeleteUser = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {name} not Deleted!
      </SweetAlert>
    );
  };

  const successUpdateUser = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setUpdateUserModal(false);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {name} has been updated!
      </SweetAlert>
    );
  };

  const failUpdateUser = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {name} has NOT been updated!
      </SweetAlert>
    );
  };

  const confirmDenyUser = (id, name) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title="Deny Request?"
        onConfirm={() => handleDeleteUser(id)}
        onCancel={() => cancelDenyUser(name)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, Deny!"
        cancelBtnText="Cancel"
        showCancel
      >
        {`${name}'s request will be denied`}
      </SweetAlert>
    );
  };

  const cancelDenyUser = () => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Cancelled
      </SweetAlert>
    );
  };

  const confirmApproveUser = (id, email, name, institution, about) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title="Approve Request?"
        onConfirm={() => handleApproveUser(id, email, name, institution, about)}
        onCancel={() => cancelApproveUser(name)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, Approve!"
        cancelBtnText="Cancel"
        showCancel
      >
        {`${name}'s request will be approved`}
      </SweetAlert>
    );
  };

  const cancelApproveUser = () => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Cancelled
      </SweetAlert>
    );
  };

  const successApproveUser = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        User Approved!
      </SweetAlert>
    );
  };

  const failApproveUser = (error) => {
    console.log("FAIL ERROR");
    console.log(error);
    const errorMessage = error;
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        User Not Approved!
      </SweetAlert>
    );
  };

  const handleSubmitAddUser = async (e) => {
    e.preventDefault();

    const adminTypeCode =
      typeNumeric == 3 ? "member_admin" : typeNumeric == 4 ? "admin" : "member";

    const postValues = {
      email: email.toLowerCase(),
      name: name,
      institution: institution,
      about: about,
      type: adminTypeCode,
      tentative: "false",
      message: "",
    };

    let updateProfile;
    /////NEED to change update profile route to see if user exists and if not create a new user.
    try {
      updateProfile = await axios.post(
        `${REACT_APP_SERVER_URL}/users`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      updateProfile = response;
    }
    if (updateProfile.status == 200) {
      successAddUser();
      getImagesUsers();
    } else {
      failAddUser(updateProfile.data.messages.databaseError);
    }
  };

  const handleSubmitUpdateUser = async (e) => {
    e.preventDefault();

    const adminTypeCode =
      typeNumeric == 3 ? "member_admin" : typeNumeric == 4 ? "admin" : "member";

    const postValues = {
      email: email,
      name: name,
      institution: institution,
      about: about,
      type: adminTypeCode,
    };

    let updateProfile;
    /////NEED to change update profile route to see if user exists and if not create a new user.
    try {
      updateProfile = await axios.put(
        `${REACT_APP_SERVER_URL}/users/${id}`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      updateProfile = response;
    }
    if (updateProfile.status == 200) {
      successUpdateUser();

      getImagesUsers();
    } else {
      failUpdateUser(updateProfile.data.messages.databaseError);
    }
  };

  async function getImagesUsers() {
    props.reloadImagesUsersCallBack(true);
  }

  const handleDeleteUser = async (id) => {
    let deleteUser;

    try {
      deleteUser = await axios.delete(
        `${REACT_APP_SERVER_URL}/users/${id}`,

        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      deleteUser = response;
    }
    if (deleteUser.status == 200) {
      successDeleteUser();
    } else {
      failDeleteUser(deleteUser.data.messages.databaseError);
    }

    props.reloadImagesUsersCallBack(true);
  };

  const handleApproveUser = async (id, email, name, institution, about) => {
    const postValues = {
      email: email,
      name: name,
      institution: institution,
      about: about,
      type: "member",
      tentative: "false",
    };

    let updateProfile;
    /////NEED to change update profile route to see if user exists and if not create a new user.
    try {
      updateProfile = await axios.put(
        `${REACT_APP_SERVER_URL}/users/${id}`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      updateProfile = response;
    }
    if (updateProfile.status == 200) {
      successApproveUser();
      getImagesUsers();
    } else {
      failApproveUser(updateProfile);
    }
  };

  const addData = (userData) => {
    userData.id && setID(userData.id);
    userData.email && setEmail(userData.email);
    userData.name && setName(userData.name);
    userData.institution && setInstitution(userData.institution);
    userData.about && setAbout(userData.about);
    userData.typeNumeric && setTypeNumeric(userData.typeNumeric);
  };

  const addTentativeData = (userData) => {
    userData.id && setID(userData.id);
    userData.email && setEmail(userData.email);
    userData.name && setName(userData.name);
    userData.institution && setInstitution(userData.institution);
  };

  const clearData = () => {
    setID("");
    setEmail("");
    setEmailState("");
    setName("");
    setInstitution("");
    setAbout("");
    setTypeNumeric("2");
    setTime("");
    setTopic("");
    setConfirmationCode("");
    setNeedTime("");
    setRole("");
    setRegistrationType("");
  };

  return (
    <div>
      {alert}

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Stats</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Select Stat Type
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        inputProps={{
                          name: "simpleSelect",
                          id: "statNumeric",
                          value: statNumeric,
                          onChange: (event) => {
                            setStatNumeric(event.target.value);
                          },
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          Select Stats Type
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="2"
                        >
                          Symposium Registrations
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="3"
                        >
                          Meeting Registrations
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="4"
                        >
                          Attendance
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="5"
                        >
                          User Email List
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="6"
                        >
                          Data Requests
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="7"
                        >
                          Chair Votes
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>

                {statNumeric > 1 && statNumeric < 4 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <br></br>
                      <h4>Total Registrations: {selectedRegistrationsTotal}</h4>
                      <h4>In Person Registrations: {inPersonRegistrations}</h4>
                      <h4>Virtual Registrations: {virtualRegistrations}</h4>
                      <br></br>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <ReactTable
                        columns={[
                          {
                            Header: "Name",
                            accessor: "name",
                          },

                          {
                            Header: "Institution",
                            accessor: "institution",
                          },

                          {
                            Header: "Role",
                            accessor: "role",
                          },
                          {
                            Header: "Registration Type",
                            accessor: "registration_type",
                          },

                          {
                            Header: "Need Time",
                            accessor: "need_time",
                          },

                          {
                            Header: "Actions",
                            accessor: "actions",
                          },
                        ]}
                        initialState={{}}
                        data={registrationData}
                        defaultPageSize={20}
                      />
                    </GridItem>
                  </GridContainer>
                )}

                {statNumeric == 4 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <br></br>
                      <h4>
                        Symposium 2022 Attendance: {symposiumAttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Spring 2022 Meeting Attendance:{" "}
                        {meetingAttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Summer 2022 Meeting Attendance:{" "}
                        {meeting0622AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Fall 2022 Meeting Attendance:{" "}
                        {meeting0922AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Winter 2022 Meeting Attendance:{" "}
                        {meeting0123AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Spring 2023 Meeting Attendance:{" "}
                        {meeting0323AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Summer 2023 Meeting Attendance:{" "}
                        {meeting0623AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Fall 2023 Meeting Attendance:{" "}
                        {meeting0923AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Winter 2023 Meeting Attendance:{" "}
                        {meeting1223AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Spring 2024 Meeting Attendance:{" "}
                        {meeting0324AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Spring 2024 Off Cycle Meeting Attendance:{" "}
                        {meeting0524AttendanceTotal}
                      </h4>
                      <h4>
                        PREVENT Fall 2024  Meeting Attendance:{" "}
                        {meeting0924AttendanceTotal}
                      </h4>

                      <br></br>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <ReactTable
                        columns={[
                          {
                            Header: "Name",
                            accessor: "name",
                          },

                          {
                            Header: "Type",
                            accessor: "type",
                          },

                          {
                            Header: "Date/Time",
                            accessor: "dateTime",
                          },

                          {
                            Header: "Actions",
                            accessor: "actions",
                          },
                        ]}
                        initialState={{}}
                        data={attendanceData}
                        defaultPageSize={20}
                      />
                    </GridItem>
                  </GridContainer>
                )}
                {statNumeric == 5 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <br></br>
                      <h4>
                        User Email List:
                        <br></br>
                        {userEmailsString}
                      </h4>

                      <br></br>
                    </GridItem>
                  </GridContainer>
                )}
                {statNumeric == 6 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <br></br>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <ReactTable
                        columns={[
                          {
                            Header: "ID",
                            accessor: "id",
                          },
                          {
                            Header: "Name",
                            accessor: "name",
                          },

                          {
                            Header: "Action",
                            accessor: "actions",
                          },
                        ]}
                        initialState={{}}
                        data={dataRequestsData}
                        defaultPageSize={20}
                      />
                    </GridItem>
                  </GridContainer>
                )}

                {statNumeric == 7 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <br></br>
                      <h4>Guillaume Emeriaud: {emeriaudVotes}</h4>
                      <h4>Samer Abu-Sultaneh: {abusultanehVotes}</h4>
                      <h4>Jocelyn R. Grunwell: {grunwellVotes}</h4>
                      <br></br>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <ReactTable
                        columns={[
                          {
                            Header: "Name",
                            accessor: "name",
                          },
                          {
                            Header: "Email",
                            accessor: "email",
                          },

                          {
                            Header: "Vote",
                            accessor: "type",
                          },
                        ]}
                        initialState={{}}
                        data={mostRecentVotes}
                        defaultPageSize={20}
                      />
                    </GridItem>
                  </GridContainer>
                )}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal,
          }}
          open={registrationInfoModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setRegistrationInfoModal(false)}
          aria-labelledby="notice-modal-slide-title"
          aria-describedby="notice-modal-slide-description"
        >
          <DialogTitle
            id="notice-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => setRegistrationInfoModal(false)}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>{name}</h4>
          </DialogTitle>
          <DialogContent
            id="notice-modal-slide-description"
            className={classes.modalBody}
          >
            <div className={classes.modalBody}>
              <GridContainer>
                {email && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Email</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{email}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {institution && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Institution</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{institution}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {role && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Role</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{role}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {registration_type && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Registration Type</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{registration_type}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {need_time && agenda_topic && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Agenda Topic</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{agenda_topic}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {need_time && agenda_time && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Agenda Time</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{agenda_time}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {confirmation_code && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Confirmation Code</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{confirmation_code}</p>
                    </GridItem>
                  </GridContainer>
                )}
              </GridContainer>
            </div>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button
              onClick={() => {
                clearData();
                setRegistrationInfoModal(false);
              }}
              color="rose"
              round
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal,
          }}
          open={dataRequestsInfoModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setDataRequestsInfoModal(false)}
          aria-labelledby="notice-modal-slide-title"
          aria-describedby="notice-modal-slide-description"
        >
          <DialogTitle
            id="notice-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => setDataRequestsInfoModal(false)}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>{name}</h4>
          </DialogTitle>
          <DialogContent
            id="notice-modal-slide-description"
            className={classes.modalBody}
          >
            <div className={classes.modalBody}>
              <GridContainer>
                {email && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Email</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{email}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {institution && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Institution</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{institution}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {description && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Description</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{description}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {type && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Type</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{type}</p>
                    </GridItem>
                  </GridContainer>
                )}
              </GridContainer>
            </div>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button
              onClick={() => {
                clearData();
                setDataRequestsInfoModal(false);
              }}
              color="rose"
              round
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </GridContainer>

      {props.tentatives.length > 0 && (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Tentative Members Table
                </h4>
              </CardHeader>
              <CardBody>
                {" "}
                <ReactTable
                  columns={[
                    {
                      Header: "Name",
                      accessor: "name",
                    },

                    {
                      Header: "Institution",
                      accessor: "institution",
                    },

                    {
                      Header: "Message",
                      accessor: "message",
                    },
                    {
                      Header: "Actions",
                      accessor: "actions",
                    },
                  ]}
                  initialState={{}}
                  data={tentativeUserData}
                  defaultPageSize={20}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      )}

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success" icon>
              <CardIcon color="success">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Users Table</h4>
            </CardHeader>
            <CardBody>
              <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal,
                }}
                open={addUserModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddUserModal(false)}
                aria-labelledby="notice-modal-slide-title"
                aria-describedby="notice-modal-slide-description"
              >
                <DialogTitle
                  id="notice-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    color="transparent"
                    onClick={() => {
                      clearData();
                      setAddUserModal(false);
                    }}
                  >
                    <Close className={classes.modalClose} />
                  </Button>
                  <h4 className={classes.modalTitle}>Add User</h4>
                </DialogTitle>
                <DialogContent
                  id="notice-modal-slide-description"
                  className={classes.modalBody}
                >
                  <div className={classes.modalBody}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <form onSubmit={handleSubmitAddUser}>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                success={emailState === "success"}
                                error={emailState === "error"}
                                labelText="Email Address *"
                                id="email"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: email,
                                  onChange: (event) => {
                                    if (verifyEmail(event.target.value)) {
                                      setEmailState("success");
                                    } else {
                                      setEmailState("error");
                                    }
                                    setEmail(event.target.value);
                                  },
                                  type: "email",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="simple-select"
                                  className={classes.selectLabel}
                                >
                                  Select Type
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  inputProps={{
                                    name: "simpleSelect",
                                    id: "typeNumeric",
                                    value: typeNumeric,
                                    onChange: (event) => {
                                      setTypeNumeric(event.target.value);
                                    },
                                  }}
                                >
                                  <MenuItem
                                    disabled
                                    classes={{
                                      root: classes.selectMenuItem,
                                    }}
                                  >
                                    Select Type
                                  </MenuItem>
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                    value="2"
                                  >
                                    Member
                                  </MenuItem>
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                    value="3"
                                  >
                                    Member and Admin
                                  </MenuItem>
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                    value="4"
                                  >
                                    Admin Only
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText="Name"
                                id="name"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: name,
                                  onChange: (event) => {
                                    setName(event.target.value);
                                  },
                                }}
                              />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText="Institution"
                                id="institution"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: institution,
                                  onChange: (event) => {
                                    setInstitution(event.target.value);
                                  },
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <InputLabel style={{ color: "#AAAAAA" }}>
                                About Me (Max Characters: 1000)
                              </InputLabel>
                              <CustomInput
                                labelText={""}
                                id="about"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: about,
                                  multiline: true,
                                  rows: 5,
                                  onChange: (event) => {
                                    setAbout(event.target.value);
                                  },
                                  maxLength: 1000,
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <Button
                            color="info"
                            className={classes.updateProfileButton}
                            type="submit"
                            disabled={
                              emailState == "success" && email.length > 0
                                ? false
                                : true
                            }
                          >
                            Add User
                          </Button>
                        </form>
                      </GridItem>
                    </GridContainer>
                  </div>
                </DialogContent>
                <DialogActions
                  className={
                    classes.modalFooter + " " + classes.modalFooterCenter
                  }
                >
                  <Button
                    onClick={() => setAddUserModal(false)}
                    color="rose"
                    round
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal,
                }}
                open={updateUserModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setUpdateUserModal(false)}
                aria-labelledby="notice-modal-slide-title"
                aria-describedby="notice-modal-slide-description"
              >
                <DialogTitle
                  id="notice-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    color="transparent"
                    onClick={() => setUpdateUserModal(false)}
                  >
                    <Close className={classes.modalClose} />
                  </Button>
                  <h4 className={classes.modalTitle}>Update User</h4>
                </DialogTitle>
                <DialogContent
                  id="notice-modal-slide-description"
                  className={classes.modalBody}
                >
                  <div className={classes.modalBody}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <form onSubmit={handleSubmitUpdateUser}>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                success={emailState === "success"}
                                error={emailState === "error"}
                                labelText="Email Address *"
                                id="email"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: email,
                                  onChange: (event) => {
                                    if (verifyEmail(event.target.value)) {
                                      setEmailState("success");
                                    } else {
                                      setEmailState("error");
                                    }
                                    setEmail(event.target.value);
                                  },
                                  type: "email",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="simple-select"
                                  className={classes.selectLabel}
                                >
                                  Select Type
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  inputProps={{
                                    name: "simpleSelect",
                                    id: "typeNumeric",
                                    value: typeNumeric,
                                    onChange: (event) => {
                                      setTypeNumeric(event.target.value);
                                    },
                                  }}
                                >
                                  <MenuItem
                                    disabled
                                    classes={{
                                      root: classes.selectMenuItem,
                                    }}
                                  >
                                    Select Type
                                  </MenuItem>
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                    value="2"
                                  >
                                    Member
                                  </MenuItem>
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                    value="3"
                                  >
                                    Member and Admin
                                  </MenuItem>
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                    value="4"
                                  >
                                    Admin Only
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText="Name"
                                id="name"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: name,
                                  onChange: (event) => {
                                    setName(event.target.value);
                                  },
                                }}
                              />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText="Institution"
                                id="institution"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: institution,
                                  onChange: (event) => {
                                    setInstitution(event.target.value);
                                  },
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <InputLabel style={{ color: "#AAAAAA" }}>
                                About Me (Max Characters: 1000)
                              </InputLabel>

                              <CustomInput
                                labelText={""}
                                id="about"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: about,
                                  onChange: (event) => {
                                    setAbout(event.target.value);
                                  },
                                  multiline: true,
                                  rows: 5,
                                  maxLength: 1000,
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <Button
                            color="info"
                            className={classes.updateProfileButton}
                            type="submit"
                          >
                            Update User
                          </Button>
                        </form>
                      </GridItem>
                    </GridContainer>
                  </div>
                </DialogContent>
                <DialogActions
                  className={
                    classes.modalFooter + " " + classes.modalFooterCenter
                  }
                >
                  <Button
                    onClick={() => setUpdateUserModal(false)}
                    color="rose"
                    round
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

              <Button
                color="info"
                className={classes.updateProfileButton}
                onClick={() => {
                  clearData();
                  setAddUserModal(true);
                }}
              >
                Add User
              </Button>

              <ReactTable
                columns={[
                  {
                    Header: "Name",
                    accessor: "name",
                  },

                  {
                    Header: "Type",
                    accessor: "type",
                  },

                  {
                    Header: "Institution",
                    accessor: "institution",
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                  },
                ]}
                initialState={{ hiddenColumns: ["type"] }}
                data={userData}
                defaultPageSize={20}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

Admin.propTypes = {
  users: PropTypes.array,
  tentatives: PropTypes.array,
  registrations: PropTypes.array,
  attendance: PropTypes.array,
  dataRequests: PropTypes.array,
  reloadImagesUsersCallBack: PropTypes.func,
  reloadTentativesCallBack: PropTypes.func,
};
